import React, { useState, useEffect, useRef } from 'react';
import MainLayout from '../../layouts/MainLayout';
import { Card, Button, message } from 'antd';
import { CreditCardOutlined, PlusOutlined } from '@ant-design/icons';
import { financeSettingsApi } from '../../utils/api';
import PaymentGatewayTab from '../../components/finance/PaymentGatewayTab';
import { TableSkeleton } from '../../components/SkeletonLoaders';

const PaymentGateway = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const childRef = useRef();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setData(null);
    setLoading(true);
    try {
      const res = await financeSettingsApi.getPaymentGateways('offline');
      const result = res?.data || res || {};
      setData(result);
    } catch (error) {
      console.error('خطا در دریافت اطلاعات:', error);
      message.error('خطا در دریافت روش‌های پرداخت');
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <div style={{ fontFamily: 'CustomFont' }}>
        <Card className="shadow-xl border-0" bodyStyle={{ padding: 0 }}>
          <div className="flex items-center justify-between flex-wrap gap-4 p-6 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 rounded-t-xl">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 text-white flex items-center justify-center shadow-lg">
                <CreditCardOutlined className="text-xl" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100 m-0">
                  درگاه پرداخت
                </h1>
                <p className="text-gray-500 dark:text-gray-400 text-sm m-0">
                  مدیریت روش‌های پرداخت 
                </p>
              </div>
            </div>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => childRef.current?.openAddModal()}
              size="middle"
              className="bg-green-600 hover:bg-green-700 border-0 shadow-md hover:shadow-lg transition-all"
              style={{ fontFamily: 'CustomFont' }}
            >
              افزودن درگاه جدید
            </Button>
          </div>

          <div className="p-3 sm:p-6 bg-gray-50 dark:bg-gray-900/50 rounded-b-xl">
            {loading ? (
              <TableSkeleton rows={5} columns={4} />
            ) : (
              <PaymentGatewayTab ref={childRef} data={data} onUpdate={loadData} />
            )}
          </div>
        </Card>
      </div>
    </MainLayout>
  );
};

export default PaymentGateway;
